import { useMemo } from "react";
import { ILead, LeadPaymentMethod, PaymentStatus } from "../../models/Lead";
import usePaymentStatus from "../../data/usePaymentStatus";
import PaymentBubble from "../../utils/paymentBubble";
import Tooltip from "../shared/Tooltip";


export default function PaymentStatusCell({ lead }: { lead: ILead }) {
  const { paymentStatus: getPaymentStatus } = usePaymentStatus(
    lead.id,
    lead.tellerooTransactionId
  );

  const paymentStatus = useMemo(() => {
    let status = lead.paymentStatus;

    //Don't go to Telleroo if no transaction ID, or if it's not a bank transfer method
    if (!lead.id ||
      !lead.tellerooTransactionId ||
      lead.tellerooTransactionId === "00000000-0000-0000-0000-000000000000" ||
      lead.paymentMethod !== LeadPaymentMethod["Bank Transfer"]) {
      return status;
    }

    if (lead.paymentStatus === PaymentStatus.Approved || lead.paymentStatus === PaymentStatus.Failed) {

      if (getPaymentStatus.isLoading) return status;

      if (getPaymentStatus.data?.data?.status) return getPaymentStatus.data?.data?.status;
    }

    return status;

  }, [lead, getPaymentStatus.isLoading, getPaymentStatus.data]);

  if (lead.id && lead.tellerooTransactionId && lead.tellerooTransactionId !== "00000000-0000-0000-0000-000000000000" && getPaymentStatus.isLoading) {
    return (
      <div className="flex justify-center items-center flex-1 animate-pulse">
        <div className="rounded-full p-3 h-7 text-sm font-semibold w-16 bg-gray-200"></div>
      </div>
    );
  }

  return (
    <div title="Payment Status" className="flex justify-center items-center flex-1 text-nowrap">
      <Tooltip content={"Payment Status"}>
        <span>{PaymentBubble(paymentStatus)}</span>  
      </Tooltip>
    </div>
  );
}